
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/info",
      function () {
        return require("private-next-pages/events/[eventId]/info/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/info"])
      });
    }
  